<template>
  <div class="dashboard-body-futuristic">
    <!-- Header Component -->


    <!-- Main Container -->
    <main class="futuristic-container" style="flex-direction: column; padding: 1rem 2rem;">

      <!-- Main Content (PDF View) -->
      <section class="dashboard-card-futuristic dashboard-card-scrollable" style="width: 100%;">
        <div class="pdf-viewer-wrapper">

          <Teleport to="#page-action-bar">
            <button class="btn-viewer-action btn-back" @click="fileListingPage">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
              </svg>
              Back
            </button>
            <h1 class="page-bar-title">Bid Summary</h1>
            <div class="page-bar-actions">
              <div class="pdf-search-wrapper">
                <svg class="pdf-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                <input
                  v-model="searchQuery"
                  type="text"
                  class="pdf-search-input"
                  placeholder="Search in document..."
                  @input="onSearchInput"
                />
                <button v-if="searchQuery" class="pdf-search-clear" @click="clearSearch" title="Clear search" aria-label="Clear search">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              <button class="btn-viewer-action btn-download" @click="downloadProtected" :disabled="isDownloading" :class="{ 'disabled': isDownloading }">
                <svg v-if="!isDownloading" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <svg v-else class="spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                {{ isDownloading ? 'Downloading...' : 'Download Excel' }}
              </button>
              <button class="btn-viewer-action btn-download" @click="downloadMiniSummary" :disabled="isDownloadingMini" :class="{ 'disabled': isDownloadingMini }" title="Download only the important heads">
                <svg v-if="!isDownloadingMini" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <svg v-else class="spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                {{ isDownloadingMini ? 'Downloading...' : 'Download Mini Summary' }}
              </button>
            </div>
          </Teleport>

          <div class="pdf-content-container table-responsive">
            <table class="pdf-content-table">
              <colgroup>
                <col style="width: 16%;"> <!-- Heads of Items -->
                <col style="width: 24%;"> <!-- Reference -->
                <col style="width: 10%;"> <!-- Clause No -->
                <col style="width: 8%;">  <!-- Page No -->
                <col style="width: 42%;"> <!-- Brief Description -->
              </colgroup>
              <thead>
                <tr>
                  <th>Heads of Items</th>
                  <th>Reference</th>
                  <th style="text-align: center;">Clause No.</th>
                  <th style="text-align: center;">Page No</th>
                  <th>Brief Description of Contract Provisions</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="filteredData.length">
                  <tr v-for="tableData in filteredData" :key="tableData.id">
                    <td><div class="cell-scroll" v-html="highlight(tableData.head_name)"></div></td>
                    <td><div class="cell-scroll" v-html="highlight(tableData.reference)"></div></td>
                    <td style="text-align: center;"><div class="cell-scroll" v-html="highlight(tableData.clause_no)"></div></td>
                    <td style="text-align: center;"><div class="cell-scroll" v-html="highlight(tableData.page_no)"></div></td>
                    <td><div class="cell-scroll" v-html="highlight(tableData.brief_description)"></div></td>
                  </tr>
                </template>
                <tr v-else>
                  <td colspan="5" style="text-align:center; padding:2rem; color:#64748b;">
                    No results found for "<strong>{{ searchQuery }}</strong>"
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <AppPagination
            v-if="!searchQuery"
            :currentPage="currentPage"
            :totalPages="totalPages"
            @page-changed="populate_summray_data"
          />
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import AppPagination from './AppPagination.vue';
import { notify } from '@/utils/notify';
//import html2pdf from "html2pdf.js";

export default {
  name: "PdfView",
  components: {
    AppPagination
  },

  data() {
    return {
      tableDataList: [],
      allTableData: [],
      currentPage: 1,
      totalPages: 1,
      searchQuery: '',
      searchTimeout: null,
      isDownloading: false,
      isDownloadingMini: false,
    };
  },

  props: {
    getAccessToken: Function,
  },

  created() {
    // Hide global header for this page too
  },

  computed: {
    filteredData() {
      const q = this.searchQuery.trim().toLowerCase();
      if (!q) return this.tableDataList;
      return this.allTableData.filter(row =>
        [row.head_name, row.reference, row.clause_no, row.page_no, row.brief_description]
          .some(val => String(val || '').toLowerCase().includes(q))
      );
    },
  },

  mounted() {
    this.populate_summray_data();
  },

  methods: {
    getAuthHeaders() {
      return {
        Authorization: 'Bearer ' + this.getAccessToken()
      };
    },

    // Carry the bid's status and originating sidebar section (`from`) along so
    // BidDetails and the criteria pages keep the same sidebar highlight.
    carriedQuery() {
      const { status, from } = this.$route.query;
      const query = {};
      if (status) query.status = status;
      if (from) query.from = from;
      return query;
    },

    fileUploadPage: function () {
      this.$router.push({ name: 'Home' });
    },
    // Back returns to the bid's Analysis tab, where the Bid Summary is opened from.
    fileListingPage: function () {
      this.$router.push({
        name: 'BidDetails',
        params: { pdf_id: this.$route.params.pdf_id },
        query: { tab: 'analysis', ...this.carriedQuery() },
      });
    },

    downloadProtected() {
      // Full Bid Summary (all heads) -> /download/summary
      return this.downloadExcel('/download/summary', 'isDownloading');
    },

    downloadMiniSummary() {
      // Mini Bid Summary (only the important heads) -> /download/mini-summary
      return this.downloadExcel('/download/mini-summary', 'isDownloadingMini');
    },

    async downloadExcel(endpoint, spinnerFlag) {
      if (this[spinnerFlag]) return;
      this[spinnerFlag] = true;

      try {
        const pdf_id = this.$route.params.pdf_id; // Get ID from route parameters

        const res = await axios.get(this.$API_URL + endpoint + "?pdf_id=" + pdf_id, {
          responseType: 'blob',
          headers: this.getAuthHeaders(),
          onDownloadProgress: (e) => {
            console.log(e)
          }
        });

        // infer filename from header if present
        let filename = 'file.xlsx';
        const disp = res.headers['content-disposition'] || res.headers['Content-Disposition'];
        if (disp) {
          const m = disp.match(/filename\*?=(?:UTF-8''|")?([^;"\n]+)/i);
          if (m && m[1]) filename = decodeURIComponent(m[1].replace(/['"]/g, ''));
        }

        // download the blob
        const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/octet-stream' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          setTimeout(() => URL.revokeObjectURL(url), 100);
        }
      } catch (err) {
        console.error('Download failed', err);
        notify.error('Couldn’t download the file. Check your connection and try again.');
      } finally {
        this[spinnerFlag] = false;
      }
    },

    highlight(text) {
      const q = this.searchQuery.trim();
      if (!q || !text) return this.escapeHtml(String(text ?? ''));
      const escaped = this.escapeHtml(String(text));
      const escapedQ = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return escaped.replace(
        new RegExp(`(${escapedQ})`, 'gi'),
        '<mark class="search-highlight">$1</mark>'
      );
    },

    escapeHtml(str) {
      return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    },

    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        if (this.allTableData.length === 0) {
          this.fetchAllData();
        }
      }, 350);
    },

    clearSearch() {
      this.searchQuery = '';
    },

    fetchAllData() {
      const pdf_id = this.$route.params.pdf_id;
      if (!pdf_id) return;
      axios.get(this.$API_URL + `/user/pdf-summary-details?pdf_id=${pdf_id}&page=1&page_size=5000`, {
        headers: this.getAuthHeaders()
      })
        .then(res => {
          this.allTableData = res.data.items;
        })
        .catch(err => console.error(err));
    },

    populate_summray_data: function (page = 1) {
      const pdf_id = this.$route.params.pdf_id;
      if (!pdf_id) return;
      this.currentPage = page;

      axios.get(this.$API_URL + `/user/pdf-summary-details?pdf_id=${pdf_id}&page=${page}&page_size=10`, {
        headers: this.getAuthHeaders()
      })
        .then(res => {
          this.tableDataList = res.data.items;
          this.totalPages = res.data.total_pages;
          // background mein sab data bhi fetch karo taaki search ready rahe
          if (this.allTableData.length === 0) {
            this.fetchAllData();
          }
        })
        .catch(err => console.error(err));
    }
  }

};
</script>

<style scoped>
/* Removed legacy styles, now using global main.css */

/* Bid Summary table header — slightly blue tint to distinguish from rows */
.pdf-content-table :deep(thead) {
  background: #e8f4fd;
}
.pdf-content-table :deep(thead th) {
  background: transparent;
  color: #0c4a6e;
  border-bottom: 2px solid #bae0f8;
}

.pdf-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.pdf-search-icon {
  position: absolute;
  left: 0.75rem;
  color: #64748b;
  pointer-events: none;
  flex-shrink: 0;
}

.pdf-search-input {
  padding: 0.5rem 2.2rem 0.5rem 2.2rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 0.88rem;
  background: #f8fafc;
  color: #1e293b;
  width: 220px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pdf-search-input:focus {
  border-color: #0071c5;
  box-shadow: 0 0 0 3px rgba(0, 113, 197, 0.12);
  background: #fff;
}

.pdf-search-input::placeholder {
  color: #64748b;
}

.pdf-search-clear {
  position: absolute;
  right: 0.55rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  padding: 0;
  transition: color 0.2s;
}

.pdf-search-clear:hover {
  color: #ef4444;
}

:deep(.search-highlight) {
  background: #fef08a;
  color: #1e293b;
  border-radius: 4px;
  padding: 0 1px;
  font-weight: 600;
}

.spin {
  animation: spin 1s linear infinite;
}

.btn-download.disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: #64748b;
  /* Grey out background if needed, or just let opacity handle it */
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}


</style>
